import AbstractChannel from './AbstractChannel'

export default class ParkPlus extends AbstractChannel {

  name = 'park_plus'
  title = 'Park Plus'
  titleShort = 'Park Plus'
  color = '#FF9896'

  supportedFeatures = ['blackouts']

}
